import * as Sentry from '@sentry/browser';

declare const sentryOptions: Sentry.BrowserOptions | undefined;

if (typeof sentryOptions !== 'undefined') {
    Sentry.init(sentryOptions);
}
